import { useState } from 'react';
import { Button } from '@mantine/core';
import { TemplateAvailabilityDrawer } from '@dealstack/frontend/app/pages/DocumentTemplates/TemplateAvailability/TemplateAvailabilityDrawer';

interface Props {
	templateId: string;
}

export const ManageAvailabilityButton = ({ templateId }: Props) => {
	const [opened, setOpened] = useState(false);

	return (
		<>
			<Button variant="ghost" onClick={() => setOpened(true)}>
				Assign
			</Button>
			{opened && (
				<TemplateAvailabilityDrawer
					templateId={templateId}
					opened={opened}
					onClose={() => setOpened(false)}
				/>
			)}
		</>
	);
};
